module.exports = __webpack_public_path__ + "media/marqeta_setup/smiley_shopper-41fece9e.png";